import { LitElement, html, css, utils, styles } from '@hh/global.js'

class AccountHeaderModal extends LitElement {
  static properties = {
    _trapFocus: {
      state: true,
    }
  }

  constructor() {
    super()

    this.handleBodyClick = this.handleBodyClick.bind(this)

    this.addEventListener(
      'transitionend',
      () => {
        this._trapFocus = true
      },
      { once: true }
    )
  }

  connectedCallback() {
    super.connectedCallback()
    document.body.addEventListener('click', this.handleBodyClick)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.body.addEventListener('click', this.handleBodyClick)
  }

  handleBodyClick(e) {
    var path = (e.composedPath && e.composedPath()) || e.path

    if (
      path.some((node) => {
        return node.matches && node.matches('account-header-modal')
      })
    ) {
      return true
    }

    if (!e.defaultPrevented && this.isOpen()) {
      this.toggle()
    }
  }

  isOpen() {
    return !!document.body.classList.contains('account-header-modal-is-active')
  }

  toggle() {
    utils.toggle(document.body, ['account-header-modal-is-active'])
  }

  static styles = [styles.visuallyHidden, css`
    .wrapper {
      height: 100%;
    }

    hh-focus-trap {
      height: 100%;
    }
  `]

  render() {
    return html`
    <div class="wrapper">
      <hh-focus-trap active="${this._trapFocus}">
        <slot name="close" @click="${this.toggle}"></slot>
        <slot name="body"></slot>
      </hh-focus-trap>
    </div> `
  }
}

customElements.define('account-header-modal', AccountHeaderModal)
